export class ProgressBar {
    static init(parent: HTMLElement, bar: HTMLElement): void {
        if (parent && bar) {
            bar.style.width = `${bar.offsetWidth}px`;
            parent.style.height = `${parent.offsetHeight}px`;
            this.handleScroll(parent, bar);
        }
    }

    static handleScroll(parent: HTMLElement, bar: HTMLElement): void {
        const handleSticky = () => {
            const viewportHeight = window.innerHeight;
            const barOffsetTop = parent.offsetTop;

            if (barOffsetTop > viewportHeight && !bar.classList.contains('wiz-progress-bar--tc')) {
                bar.classList.add('wiz-progress-bar--sticky');
            } else {
                bar.classList.remove('wiz-progress-bar--sticky');
            }
        };

        setTimeout(() => {
            handleSticky();
            bar.style.opacity = '';
        }, 250);

        window.addEventListener('scroll', handleSticky);
    }
}
